<div class="input-wrapper">
  <input #input matInput [(ngModel)]="value" placeholder="YYYY-MM-DD" autocomplete="off" [style.width.px]="cellWidth"
    [style.height.px]="cellHeight" (input)="formatDateOnInput()" (keydown)="onKeyDown($event)"
    (blur)="validateAndFormatInput()" (keydown.enter)="validateAndFormatInput()" data-testid="date-picker-input">
  <mat-icon class="clear-icon" (click)="clearInput($event)" (keydown.enter)="clearInput($event)"
    tabindex="0" aria-label="Clear date" data-testid="date-picker-clear-icon">close</mat-icon>
</div>
<div class="calendar-container calendar-popup ag-custom-component-popup">
  <div class="arrow-up"></div>
  <mat-calendar [(selected)]="value" (selectedChange)="onDateSelected($event)" [startAt]="value"
    data-testid="date-picker-calendar" [minDate]="minDate" [maxDate]="maxDate"></mat-calendar>
</div>